/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {
  closeModal, userData, switchModal,
} from '../../actions';
import Girl from '../../assets/login/girl.svg';
import X from '../../assets/login/x.svg';
import { ages, jobs } from '../../accountOptions';

class Register2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      age: '',
      job: '',
    };
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleNext = () => {
    this.setState((prevState) => {
      return {
        ageError: !prevState.age,
        jobError: !prevState.job,
      };
    }, () => {
      if (
        !this.state.ageError
        && !this.state.jobError
      ) {
        const object = {
          occupation: this.state.job,
          age: this.state.age,
        };
        this.props.userData(object);
        this.props.switchModal('Register3');
      }
    });
  }

  render() {
    return (
      <div className="modal">
        <img className="x-icon" onClick={this.props.closeModal} src={X} alt="x" />
        <div className="sign-in-container">
          <img src={Girl} alt="person" />
          <div className="sign-in-body">
            <div className="sign-in-header">
              Create an Account
            </div>
            <div className="sign-in-text">
              These will assist in our research to improve the product over time.
            </div>
            <div className="sign-in-form-row sign-in-dropdown">
              {this.state.ageError ? <p className="modal-form-error">This field cannot be left blank</p> : null}
              <FormControl>
                <InputLabel id="-controlled-open-select-label">Age</InputLabel>
                <Select
                  labelId="-controlled-open-select-label"
                  id="-controlled-open-select"
                  name="age"
                  onChange={this.handleChange}
                  value={this.state.age}
                >
                  {ages.map((age) => (
                    <MenuItem value={age}>{age}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="sign-in-form-row sign-in-dropdown">
              {this.state.jobError ? <p className="modal-form-error">This field cannot be left blank</p> : null}
              <FormControl>
                <InputLabel id="demo-controlled-open-select-label">Currently, I am</InputLabel>
                <Select
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  name="job"
                  onChange={this.handleChange}
                  value={this.state.job}
                >
                  {jobs.map((job) => (
                    <MenuItem value={job}>{job}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <br /><br />
            <div className="sign-in-bubble">
              <input type="button" value="Next" className="sign-in-button" onClick={() => { this.handleNext(); }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    toggle: state.modal.clicked,
    authError: state.user.authError,
  }
);

export default connect(mapStateToProps, {
  closeModal, userData, switchModal,
})(Register2);
